import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { NotAuthenticatedService as NotAuthenticated } from './auth-guard.service';
import { CallbackComponent } from '../callback/callback.component';

const routes: Routes = [
{ path: 'login', component: LoginComponent,  canActivate: [NotAuthenticated] },
{ path: 'callback', component: CallbackComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
